import { Directive, ElementRef, forwardRef, HostListener, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: '[nimbusNumber][formControlName],[nimbusNumber][formControl],[nimbusNumber][ngModel]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ValidNumberDirective),
      multi: true,
    },
  ],
  standalone: false,
})
export class ValidNumberDirective implements ControlValueAccessor {
  @Input()
  public required: boolean = false;

  private readonly VIEW_VALID_SYMBOLS: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-'];

  private onControlChanged: (value: number | null) => void;

  public constructor(private elementRef: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event'])
  public onInput(event: KeyboardEvent): void {
    const inputValue: string = (event.target as HTMLInputElement).value || '';
    this.parseInputValue(inputValue);
  }

  public registerOnChange(fn: (value: number | null) => void): void {
    this.onControlChanged = fn;
  }

  public registerOnTouched(_: () => {}): void {}

  public registerOnValidatorChange(_: () => void): void {}

  public writeValue(value: string): void {
    value = typeof value === 'undefined' || value === null ? '' : value;
    this.elementRef.nativeElement.value = value;
  }

  private parseInputValue(inputValue: string): void {
    const values: string[] = inputValue.split('');
    let isHaveDot = false;
    for (let i = 0; i < values.length; i++) {
      if (values[i] === '-' && (i !== 0 || values.length === 1)) {
        values[i] = null;
      }

      if (values[i] === '.') {
        if (i === 0) {
          values[i] = null;
        } else if (values[i - 1] === '-') {
          values[i] = null;
        } else if (!isHaveDot) {
          isHaveDot = true;
        } else if (isHaveDot) {
          values[i] = null;
        }
      }

      if (this.VIEW_VALID_SYMBOLS.indexOf(values[i]) < 0) {
        values[i] = null;
      }
    }
    const joined = values.join('');
    const result = !this.required && joined === '' ? null : Number(joined);
    if (this.onControlChanged) {
      this.onControlChanged(result);
    }
    this.elementRef.nativeElement.value = result !== null ? result.toString() : '';
  }
}
